import { createContext, ReactNode, useContext } from 'react';

/** What a host supplies so the form step panel can open the form builder. Routes belong to the
 * host, so every href and every navigation goes through it. */
export interface IFormBuilderLinks {
  getEditHref(formId: string): string;
  openHref(href: string): void;
  /** Given, the panel offers "View form", which opens the form where the host chooses rather than
   * navigating. `label` is the step's name, so the host can title whatever it opens it in. Absent
   * means the host has nowhere to show a form in place, and no such action renders. */
  onViewForm?(formId: string, label: string): void;
}

// Undefined everywhere but inside a host that provides links. The panel then renders no builder
// entry, so nothing changes for the other hosts of the editor.
const FormBuilderLinksContext = createContext<IFormBuilderLinks | undefined>(
  undefined
);

export const useFormBuilderLinks = (): IFormBuilderLinks | undefined =>
  useContext(FormBuilderLinksContext);

interface FormBuilderLinksProviderProps {
  links: IFormBuilderLinks;
  children: ReactNode;
}

export const FormBuilderLinksProvider = ({
  links,
  children,
}: FormBuilderLinksProviderProps) => (
  <FormBuilderLinksContext.Provider value={links}>
    {children}
  </FormBuilderLinksContext.Provider>
);
